import { useCallback } from "react";
import { Image, Pressable } from "react-native";

import { Col, Col1, Icon, Row } from "../lib";
import { colors, createStyles, sizes } from "../theme";
import { PhotoBanner } from "./photo-banner";

type Props = {
  banned?: boolean;
  disabled?: boolean;
  id: number;
  first?: boolean;
  last?: boolean;
  onDelete: (id: number) => void;
  onMoveDown: (id: number) => void;
  onMoveUp: (id: number) => void;
  url: string;
  verified?: boolean;
};

export function PhotoListItem({
  banned = false,
  disabled = false,
  id,
  first = false,
  last = false,
  onDelete,
  onMoveDown,
  onMoveUp,
  url,
  verified = false,
}: Props) {
  // Handlers
  const handleMoveUp = useCallback(() => {
    onMoveUp(id);
  }, [id, onMoveUp]);

  const handleMoveDown = useCallback(() => {
    onMoveDown(id);
  }, [id, onMoveDown]);

  const handleDelete = useCallback(() => {
    onDelete(id);
  }, [id, onDelete]);

  // Render
  return (
    <Row.LR p="4" style={[$.container, disabled && $.disabled]}>
      <Col>
        <Image source={{ uri: url }} style={{ width: 200, height: 200 }} />
        {first && <PhotoBanner icon="face-woman-shimmer" label="Default" />}
        {!!banned && <PhotoBanner icon="block-helper" label="Banned" />}
        {!!verified && <PhotoBanner icon="check" label="Verified" />}
      </Col>
      <Col1.C style={$.actions}>
        {!first && (
          <Pressable onPress={handleMoveUp} disabled={disabled}>
            <Icon large name="arrow-up" em />
          </Pressable>
        )}
        {!last && (
          <Pressable onPress={handleMoveDown} disabled={disabled}>
            <Icon large name="arrow-down" em />
          </Pressable>
        )}
      </Col1.C>
      <Pressable onPress={handleDelete} disabled={disabled} style={$.icon}>
        <Icon name="delete-outline" />
      </Pressable>
    </Row.LR>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "surface",
    borderBottomWidth: 1,
    borderBottomColor: colors.outline,
    gap: sizes["2"],
  },
  disabled: {
    opacity: 0.5,
  },
  actions: {
    gap: sizes["2"],
  },
  icon: {
    p: "4",
  },
});
